/*
 * � 2020 Microsoft. All rights reserved.
 */

define('SolitaireShared/FreeCellTemplate/FreeCellWindowsTemplate',['lodash',
        'pixi',
        'util/eventhandler',
        'Arkadium/GameEngine/Core/EngineManagers',
        'CardUI/SupplyView',
        'CardUI/PileView',
        'CardUI/KeyboardNavigator',
        'SolitaireShared/CardLogic/Supply',
        'SolitaireShared/FreeCellLogic/FreeCellAuthority',
        'SolitaireShared/FreeCellTemplate/FreeCellInputInterpreter',
        'SolitaireShared/FreeCellTemplate/FreeCellCardAnimator',
        'Arkadium/GameEngine/Maths/Vector2',
        'util/SettingsManager',
        'absolute'],
    function (_, PIXI, EventHandler, EngineManagers, SupplyView, PileView, KeyboardNavigator,
        Supply, FreeCellAuthority, FreeCellInputInterpreter, FreeCellCardAnimator, Vector2, SettingsManager, Absolute) {
        "use strict";

        var FreeCellWindowsTemplate = function () {
            this.initFreeCellWindowsTemplate();
        };

        FreeCellWindowsTemplate.prototype.initFreeCellWindowsTemplate = function () {
            this._authorityReference = null;
        };


        FreeCellWindowsTemplate.prototype.CreateAuthority = function (challenge) {
            var authority = challenge != null
                ? challenge.ConstructAuthority()
                : new FreeCellAuthority();

            authority.Setup();
            authority.CardSupply.DeckSeed = null;
            this._authorityReference = authority;

            return authority;
        };

        FreeCellWindowsTemplate.prototype.Cleanup = function () {
        };

        FreeCellWindowsTemplate.prototype.CreateInputInterpreter = function (authority) {
            return new FreeCellInputInterpreter(authority);
        };

        FreeCellWindowsTemplate.prototype.CreateCardAnimator = function (supplyView) {
            return new FreeCellCardAnimator(supplyView);
        };

        FreeCellWindowsTemplate.prototype.TryAutoSolve = function (supplyView) {
        };

        FreeCellWindowsTemplate.prototype.StopAutoSolving = function () {
        };

        FreeCellWindowsTemplate.prototype.DoLayoutPiles = function (renderManager, supplyView) {
            var isLeft = SettingsManager.getSetting('freecell', 'layoutDirection') === '1';
            var width = EngineManagers.Display.Width;
            var height = EngineManagers.Display.Height;

            _.forEach(supplyView.CardSupply.GetPileList(), function (p) {
                if (p != null) {
                    var pileView = supplyView.GetPileView(p);
                    if (pileView != null)
                        pileView.Keyboard.ResetKeypressHandlers();
                }
            });


            var foundationOrder =
                [
                    PileView.Display.Heart,
                    PileView.Display.Club,
                    PileView.Display.Diamond,
                    PileView.Display.Spade
                ];

            var pile;
            var pileScale = 1.0;
            var cardScale = 0.98;
            var rowScale = 0.75; // TODO adjust for width
            var half = (0.75 / 18.0);

            if (width / height < 1.5) {
                cardScale *= 0.85;
                rowScale *= 0.85;
                half *= 0.85;
            }
            var topRow = .175 - .5; //0.20f - .5f;
            var facedownRow = .41 - .5; // 0.45f - .5f;
            var tabRow = facedownRow; // 0.45f - .5f;
            var col =
                [
                    (0.5 / 8.0 - 0.5) * rowScale,
                    (1.5 / 8.0 - 0.5) * rowScale,
                    (2.5 / 8.0 - 0.5) * rowScale,
                    (3.5 / 8.0 - 0.5) * rowScale,
                    (4.5 / 8.0 - 0.5) * rowScale,
                    (5.5 / 8.0 - 0.5) * rowScale,
                    (6.5 / 8.0 - 0.5) * rowScale,
                    (7.5 / 8.0 - 0.5) * rowScale
                ];


            for (var i = 0; i < 8; i++) {
                pile = supplyView.GetPileView("Tableau" + i);
                pile.CardFacing = PileView.Facing.FaceUp;
                pile.PileMode = PileView.Layout.FanDown;
                if (Absolute.Platform.isMobile())
                    pile.DefaultPileSpacing = new Vector2(0, 60 / 209.0 * cardScale);
                else
                    pile.DefaultPileSpacing = new Vector2(0, 48 / 209.0 * cardScale);
                pile.LogicalScreenPos = new Vector2(col[i], tabRow);
                pile.InteractionMode = PileView.Interaction.Drag;
                pile.DisplayType = PileView.Display.Blank;

                pile.HeightLimit = 0.97;

                if (Absolute.Platform.isMobile()) {
                    if (!Absolute.ScreenMetrics.isPortrait()) {
                        if (this._authorityReference.IsChallenge)
                            pile.HeightLimit = 0.75;
                        else
                            pile.HeightLimit = 0.85;
                    }
                }


                pile.ScaleX = 1.0;
                pile.ScaleY = 1.0;
                pile.KeyboardMode = PileView.KeyboardModes.AllCardsAndEmpty;

                pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.ShiftTab, supplyView.GetPileView("Foundation0"));

                if (i > 0) {
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Left, supplyView.GetPileView("Tableau" + (i - 1)));
                }

                if (i < 7) {
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Right, supplyView.GetPileView("Tableau" + (i + 1)));
                }

                if (i < 4) {
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Up, supplyView.GetPileView("Free" + (i)));
                    if (i != 0)
                        pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Down, supplyView.GetPileView("Free" + (i)));
                } else {
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Up, supplyView.GetPileView("Foundation" + (i - 4)));
                    if (i != 7)
                        pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Down, supplyView.GetPileView("Foundation" + (i - 4)));
                }
            }
            supplyView.DefaultKeyboardFocus = supplyView.GetPileView("Tableau0");
            for (var i = 0; i < 4; i++) {
                pile = supplyView.GetPileView("Free" + i);
                pile.CardFacing = PileView.Facing.FaceUp;
                pile.PileMode = PileView.Layout.Pile;
                var column = isLeft ? col[i] - half : col[i + 4] + half;
                pile.LogicalScreenPos = new Vector2(column, topRow);
                pile.InteractionMode = PileView.Interaction.Drag;
                pile.ScaleX = pileScale;
                pile.ScaleY = pileScale;
                pile.DisplayType = PileView.Display.Tableau;
                pile.KeyboardMode = PileView.KeyboardModes.TopCardAndEmpty;
                pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Tab, supplyView.GetPileView("Foundation0"));
                pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.ShiftTab, supplyView.GetPileView("Tableau0"));
                if (i > 0) {
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Left, supplyView.GetPileView("Free" + (i - 1)));
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Up, supplyView.GetPileView("Tableau" + i));
                }
                pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Right,
                    i < 3
                        ? supplyView.GetPileView("Free" + (i + 1))
                        : supplyView.GetPileView("Foundation0"));
                pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Down, supplyView.GetPileView("Tableau" + i));
            }

            for (var i = 0; i < 4; i++) {
                pile = supplyView.GetPileView("Foundation" + i);
                pile.CardFacing = PileView.Facing.FaceUp;
                pile.PileMode = PileView.Layout.Pile;
                var column = isLeft ? col[i + 4] + half : col[i] - half;
                pile.LogicalScreenPos = new Vector2(column, topRow);
                pile.InteractionMode = PileView.Interaction.Drag;
                pile.ScaleX = pileScale;
                pile.ScaleY = pileScale;
                pile.DisplayType = foundationOrder[i];
                pile.KeyboardMode = PileView.KeyboardModes.TopCardAndEmpty;
                pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Tab, supplyView.GetPileView("Tableau0"));
                pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.ShiftTab, supplyView.GetPileView("Free0"));
                pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Left,
                    i > 0
                        ? supplyView.GetPileView("Foundation" + (i - 1))
                        : supplyView.GetPileView("Free" + 3));
                if (i < 3)
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Right, supplyView.GetPileView("Foundation" + (i + 1)));
                if (i != 3)
                    pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Up, supplyView.GetPileView("Tableau" + (i + 4)));

                pile.Keyboard.RegisterKeypressHandler(KeyboardNavigator.KeyPress.Down, supplyView.GetPileView("Tableau" + (i + 4)));
            }

            pile = supplyView.GetPileView("Stock");
            pile.LogicalScreenPos = new Vector2(0.5 - 0.5, 0.89 - 0.5);
            pile.DisplayType = PileView.Display.Blank;
            pile.CardFacing = PileView.Facing.FaceDown;

            pile = supplyView.GetPileView("Root");
            pile.LogicalScreenPos = new Vector2(-99, -99);
            pile.DefaultPileSpacing = new Vector2(0, 0);
            pile.CardFacing = PileView.Facing.Hidden;
            pile.PileMode = PileView.Layout.Pile;
            pile.InteractionMode = PileView.Interaction.None;

            supplyView.DefaultKeyboardFocus = supplyView.GetPileView("Tableau0");

            supplyView.CardScale = cardScale;
        };

        FreeCellWindowsTemplate.prototype.LoadGameOptions = function (supply) {            
            if (SettingsManager.getSetting('freecell', 'difficulty') === undefined) {
                SettingsManager.setSetting('freecell', 'difficulty', "RANDOM");
            }

            supply.SetOption("Difficulty", SettingsManager.getSetting('freecell', 'difficulty'));

            if (SettingsManager.getSetting('freecell', 'layoutDirection') === undefined) {
                SettingsManager.setSetting('freecell', 'layoutDirection', '1');
            }
        };

        FreeCellWindowsTemplate.prototype.SaveGameOptions = function (supply) {
        };

        Object.defineProperty(FreeCellWindowsTemplate.prototype, "EndGameStatStrings",
            {
                get: function () {
                    return ["Time"];
                }
            });

        FreeCellWindowsTemplate.prototype.GetEndGameStats = function () {
            return [
                this._authorityReference.CardSupply.CurrentTime.ToString()
            ];
        }

        Object.defineProperty(FreeCellWindowsTemplate.prototype, "GameName", {
            get: function () {
                return "FreeCell";
            }
        });
        Object.defineProperty(FreeCellWindowsTemplate.prototype, "SaveFilename", {
            get: function () {
                return "FREECELL_SAVE_FILE";
            }
        });

        return FreeCellWindowsTemplate;


    });

